import React, { useContext } from "react";
import { Text, TouchableOpacity, View, Image } from "react-native";
import { LanguageContext } from "../../context/LanguageContext";
import styles from "../../components/LanguageSelector/styles";

export default function LanguageSelector() {
  const { lang, changeLanguage } = useContext(LanguageContext);

  return (
    <View style={styles.langContainer}>
      <TouchableOpacity
        style={lang === "pt-BR" ? styles.langButtonSelected : styles.langButton}
        onPress={() => changeLanguage("pt-BR")}
      >
        <Image
          source={require("../../../assets/flags/bandeira-br.png")}
          style={styles.flagIcon}
        />
        <Text
          style={lang === "pt-BR" ? styles.langLabelPressed : styles.langLabel}
        >
          PT-BR
        </Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={lang === "it" ? styles.langButtonSelected : styles.langButton}
        onPress={() => changeLanguage("it")}
      >
        <Image
          source={require("../../../assets/flags/bandeira-it.png")}
          style={styles.flagIcon}
        />
        <Text
          style={lang === "it" ? styles.langLabelPressed : styles.langLabel}
        >
          IT
        </Text>
      </TouchableOpacity>
    </View>
  );
}
